<div class="bg-retiro-cli">
    <div class="numerolocker"><span>{{casillero}}</span></div>
</div>
<button class="btn btnl btnv" (click)="volver()">
    Volver
</button>
